import countryCodes from '../../../data/country-codes.json';

export const CountryList = () => {
	// generating country code dropdown data
	let countryCodesList = [];
	_.forEach(countryCodes.topCountriesList.CH, function (row) {
		countryCodesList.push({
			value: row.country_code,
			label: `${row.country_code} - ${row.name}`
		});
	});
	_.forEach(countryCodes.topCountriesList.APAC, function (row) {
		let index = countryCodesList.findIndex(x => x.value === row.country_code);
		if(index == -1) {
			countryCodesList.push({
				value: row.country_code,
				label: `${row.country_code} - ${row.name}`
			});
		}
	});
	_.forEach(countryCodes.countries, function (row) {
		let index = countryCodesList.findIndex(x => x.value === row.country_code);
		if(index == -1) {
			countryCodesList.push({
				value: row.country_code,
				label: `${row.country_code} - ${row.name}`
			});
		}
	});

	return countryCodesList;

}